import React, { memo, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAxios from '../axios/useAxios';
import PopupPayment from './PopupPayment';
import ApplePay from './Stripe/ApplePay';
import cgu from '../pdf/CGU.pdf';
import confidentialite from '../pdf/politique.pdf';
import loadingSvg from '../styles/img/loader.svg';
import {
  isAllowedToPay,
  isAppleEcosystem,
  MINIMUM_PRICE,
} from '../utils/Validator';
import { notifySuccess, notifyWarning } from '../utils/Notify';
import KRGlue from '@lyracom/embedded-form-glue';
import { getUserEmail } from '../utils/StringUtils';
import { successPaidOrder } from '../actions/cartActions';
import { addUsedPromo } from '../actions/userActions';
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js';
import { CheckoutContext, useCheckout } from '../context/checkoutProvider';
import './Checkout.scss';
import toileGRoupe from '../styles/img/halloween/toile-groupe.svg';
import PaymentLoader from '../components/loader/PaymentLoader';
import { useTheme } from 'styled-components';
import { useOrderLogger } from '../hooks/useOrderLogger';
import { isPhoneValid } from '../utils/phoneNumber/validation';
import { clearPhoneNumberError, setPhoneNumberError } from '../actions/phoneActions';
import { logMidiDealEvent } from '../actions/midiDealActions';

const Checkout = ({
                    edenredErrorMessage,
                    setEdenredErrorMessage,
                    edenredIsLoading,
                    promoLoaded,
                    isPayzenApplePayLoading,
                    setIsPayzenApplePayLoading,
                  }) => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const conecs = useSelector((state) => state.user.conecs);
  const user = useSelector((state) => state.user);
  const [conecsBalance, setConecsBalance] = useState();
  const [checkedCB, setCheckedCB] = useState('');
  const [payBtn, setPayBtn] = useState(true);
  const [paddingBottom, setPaddingBottom] = useState('20rem');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loadingpayment, setLoadingpayment] = useState(false);
  const [date, setDate] = useState();
  const [paymentErrorMessage, setPaymentErrorMessage] = useState('');
  const phoneState = useSelector((state) => state.phone);
  const phoneNumber = phoneState?.phoneNumber;
  const [isPaymentSheetReady, setIsPaymentSheetReady] = useState(false);


  const { logPaymentMethodSlider } = useOrderLogger();
  // const payzenTokenRef = useRef(undefined);

  const paygreenjsRef = useRef(window.paygreenjs);
  const { cartItems } = cart;
  const cbRef = useRef();

  const isPayzenModule = store?.paymentsGateway?.CB === 'payzen'; // TODO : rename

  const dispatchData = (data, payzenSavedCard) => {
    dispatch(successPaidOrder(data));
    dispatch(
      addUsedPromo(
        user,
        axiosInstance,
        cartItems,
        !!payzenSavedCard,
        payzenSavedCard,
      ),
    );
  };

  const updateOrder = (
    email,
    paymentIntent,
    paymentMethod,
    payzenSavedCard,
  ) => {
    const userEmail = email;
    axiosInstance
      .put(`/orders/${cartItems._id}/pay`, {
        userEmail,
        paymentIntent,
        paymentMethod,
      })
      .then((response) => {
        dispatchData(response.data, payzenSavedCard);
      })
      .catch((error) => {
        console.error({ error });
      });
  };

  const PAYMENT_STATUS_AUTHORIZED = 'AUTHORISED';
  const PAYMENT_STATUS_PAID = 'PAID';

  const isPayzenPaymentSuccessful = (payzenResponse) => {
    if (payzenResponse?.answer?.transactions) {
      const transactions = payzenResponse.answer.transactions;

      return (
        Array.isArray(transactions) &&
        transactions.some(
          (transaction) =>
            transaction.detailedStatus === PAYMENT_STATUS_AUTHORIZED &&
            transaction.status === PAYMENT_STATUS_PAID,
        )
      );
    }

    return false;
  };

  const checkIfOrderhasBeenAlreadyPaid = async (orderId) => {
    if (!isPayzenModule) return;

    try {
      const currentOrder = await axiosInstance.get(
        `/orders/payzen-payment-orders/${orderId}`,
      );

      const isPaymentValid = isPayzenPaymentSuccessful(currentOrder.data);
      if (isPaymentValid) {
        const data = {
          order: { ...cartItems, isPaid: true },
        };
        dispatch(successPaidOrder(data));
      }
    } catch (error) {
      console.error('checkIfOrderhasBeenAlreadyPaid error', error);
    }
  };

  useEffect(() => {
    var today = new Date();
    if (today.getDay() === 0) setDate('sunday');

    try {
      if (localStorage.getItem('Conecs'))
        setConecsBalance(
          JSON.parse(localStorage.getItem('Conecs')).balance / 100,
        );
    } catch (error) {
      console.error({ error });
    }

    checkIfOrderhasBeenAlreadyPaid(cartItems._id);
  }, []);

  window.addEventListener('Conecs', () => {
    if (localStorage.getItem('Conecs')) {
      setConecsBalance(
        JSON.parse(localStorage.getItem('Conecs')).balance / 100,
      );
    }
  });

  const vibrationButton = () => {
    if (document.querySelector('.conditioncheckbox')) {
      document
        .querySelector('.conditioncheckbox')
        .classList.add('vibrationred');
      setTimeout(() => {
        document
          .querySelector('.conditioncheckbox')
          .classList.remove('vibrationred');
      }, 1000);
    }
  };

  const paymentPopup = () => {
    try {

      if (!isAllowedToPay(cartItems)) {
        notifyWarning(
          `Panier inférieur à ${MINIMUM_PRICE}€`,
          'Le montant total du panier doit être d\'un montant minimum de 1€ pour passer à l\'étape de paiement.',
        );
        return;
      }

      if ((!phoneNumber || !isPhoneValid(phoneNumber)) && !user?._id) {
        dispatch(clearPhoneNumberError());
        setTimeout(() => {
          dispatch(setPhoneNumberError());
        }, 0);
        return;
      }

      if (cartItems?.midiDeal) {
        dispatch(logMidiDealEvent(axiosInstance, {
          event: 'midideal.checkout.started',
          orderId: cartItems._id,
          storeId: store?.id,
          midiDealData: {
            dealPrice: store?.midiDeal?.dealPrice,
            timeSlot: store?.midiDeal?.timeSlot,
            isActive: cartItems.midiDeal?.isActive,
            items: cartItems.midiDeal?.items,
            savings: cartItems.midiDeal?.savings,
          },
        }));
      }

      handleOpen(!isPopupOpen);

    } catch (error) {
      console.error('paymentPopup error', error);
    }
  };

  const handleOpen = (openEvent) => {
    if (isPopupOpen !== openEvent) {
      setIsPopupOpen(openEvent);
      logPaymentMethodSlider(cartItems?._id, openEvent, cartItems?.userId);
    }
  };

  useEffect(() => {
    if (cartItems.isPaid === true) {
      handleOpen(false);
    }
  }, [cartItems]);
  const handleBalance = (balanceEvent) => {
    // setEdenredBalance(balanceEvent);
  };

  const handleCheckedCB = (cbEvent) => {
    setCheckedCB(cbEvent);
  };

  useEffect(() => {
    const cartOrder = document.getElementById('cartOrder');
    if (cartOrder) cartOrder.style.paddingBottom = paddingBottom;
  }, [paddingBottom]);

  const setPayzenToken = (event) => {
    console.log('setPayzen:: ', event);
  };

  const handlePayzenLoading = (loadingStatus) => {
    setIsPayzenApplePayLoading(loadingStatus);
  };

  return paygreenjsRef ? (
    <>
      <div className="flex flex-col items-center justify-end pt-6  payer_container">
        <div className="w-[90%] rounded-[1em] overflow-hidden mt-[10px] relative">
          {isPayzenModule && promoLoaded ? (
            <>
              {/*{localStorage.getItem('token') && JSON.parse(localStorage.getItem('token')).paymentToken ? (*/}
              {/*{payzen && payzen.paymentToken ? (*/}
              <PayzenApplePayButton handlePayzenLoading={handlePayzenLoading} cartItems={cartItems}
                                    userId={user?._id} />
            </>
          ) : (
            <ApplePay
              order={cartItems}
              axiosInstance={axiosInstance}
              setPaymentErrorMessage={setPaymentErrorMessage}
            />
          )}
        </div>
        {!isPayzenApplePayLoading ? (
          <div className="flex items-center payer w-[90%] bottom-btn-shadow ">
            <div
              className={'w-full flex items-center justify-center payer p-6 '}
              onClick={paymentPopup}
            >
              {/*<p>*/}
              {/*  {payzen ? (*/}
              <PayByCardButton isPayzenModule={isPayzenModule} isSheetReady={isPaymentSheetReady} />
              {/*) : (*/}
              {/*  <img className="w-10" src={loadingSvg} alt="" />*/}
              {/*)}*/}
              {/*</p>*/}
            </div>
          </div>
        ) : (
          <></>
        )}
        {!isPopupOpen ? (
          <>
            {payBtn ? (
              <></>
            ) : (
              <>
                <div className="flex justify-center">
                  <div className="scale-50 lds-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <></>
        )}
        <PopupPayment
          ref={cbRef}
          open={handleOpen}
          openStatus={isPopupOpen}
          order={cartItems}
          store={store}
          axiosInstance={axiosInstance}
          edBalance={handleBalance}
          cb={handleCheckedCB}
          paymentErrorMessage={paymentErrorMessage}
          setPaymentErrorMessage={setPaymentErrorMessage}
          edenredErrorMessage={edenredErrorMessage}
          setEdenredErrorMessage={setEdenredErrorMessage}
          edenredIsLoading={edenredIsLoading}
          isPayzenModule={isPayzenModule}
          promoLoaded={promoLoaded}
          setPayzenToken={setPayzenToken}
          onSheetReady={setIsPaymentSheetReady}
        />
      </div>
    </>
  ) : (
    <>Loading....</>
  );
};

const PayzenApplePayButton = memo(({ handlePayzenLoading, cartItems, userId }) => {
  const { checkoutState } = useCheckout();
  const dispatch = useDispatch();
  const [showGooglePayButton, setShowGooglePayButton] = useState(false);
  const payzen = checkoutState?.payzen?.token;
  const googlePayRender = checkoutState?.payzen?.googlePayRender || false;

  const phoneState = useSelector((state) => state.phone);
  const phoneNumber = phoneState?.phoneNumber;

  const canPay = phoneNumber && isPhoneValid(phoneNumber) && !userId;

  function updateClassnameGooglePay() {
    const userAgent = navigator?.userAgent;
    const isSamsungBrowser = /SamsungBrowser/i.test(userAgent);

    let classNameGooglePayButton = 'w-full';

    if (isAppleEcosystem()) classNameGooglePayButton += ' hidden';
    else classNameGooglePayButton += ' block';

    if (showGooglePayButton && !isSamsungBrowser) classNameGooglePayButton += ' visible';
    else classNameGooglePayButton += ' invisible';

    return classNameGooglePayButton;
  }

  const validatePhoneBeforePayment = () => {
    if (!phoneNumber || !isPhoneValid(phoneNumber)) {
      dispatch(clearPhoneNumberError());
        setTimeout(() => {
          dispatch(setPhoneNumberError());
        }, 0);
      return false;
    }
    return true;
  };

  function updateApplePayCustomButton() {
    const button = document.getElementById('APPLE_PAY_BUTTON_CUSTOM');

    if (button) {
      button.style.visibility = 'visible';
      button.style['-apple-pay-button-style'] = 'black';
      button.style['-webkit-appearance'] = '-apple-pay-button';

      button.onclick = (e) => {
        if (!validatePhoneBeforePayment() && !userId) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      if (!canPay) {
        button.style.cursor = 'not-allowed';
      } else {
        button.style.cursor = 'pointer';
      }
    }
  }

  function waitForKrGoogleFormElement(selector) {
    const maxWaitTime = 6000;
    let timeoutId;

    const existingElement = document.querySelector(selector);
    if (existingElement) {
      handlePayzenLoading(false);
      setShowGooglePayButton(true);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        clearTimeout(timeoutId);
        handlePayzenLoading(false);
        setShowGooglePayButton(true);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    timeoutId = setTimeout(() => {
      observer.disconnect();
      console.warn(`Timeout: Element ${selector} not found`);
      handlePayzenLoading(false);
    }, maxWaitTime);
  }

  function updateGooglePayCustomButton() {
    const buttonGpay = document.getElementById('GOOGLE_PAY_BUTTON_CUSTOM');
    const hiddenPayzenButton = document.getElementById('GOOGLE_PAY_BUTTON_CUSTOM_PAYZEN');

    // if (buttonGpay && hiddenPayzenButton) {
    //   buttonGpay.style.position = 'relative';
    //   buttonGpay.style.zIndex = '0';
    //   buttonGpay.onclick = null;
    //
    //   hiddenPayzenButton.style.height = '60px';
    //   hiddenPayzenButton.style.top = '5rem';
    // }

    const selectorKrSmartButtonGP = '.kr-smart-button.kr-googlepay[kr-payment-method="googlepay"]';
    waitForKrGoogleFormElement(selectorKrSmartButtonGP);
  }

  const clickGooglePayButton = () => {

    if (!validatePhoneBeforePayment() && !userId) {
      return;
    }

    const selectorKrSmartButtonGP = '.kr-smart-button.kr-googlepay[kr-payment-method="googlepay"]';
    const element = document.querySelector(selectorKrSmartButtonGP);
    if (element) {
      console.info('user clicked Google Pay button');
      element.click();
    }
  };

  const classNameGooglePayButton = updateClassnameGooglePay();

  if (checkoutState?.payzen?.initialized) {
    setTimeout(() => {
      updateApplePayCustomButton();
      updateGooglePayCustomButton();
    }, 250);
  }

  useEffect(() => {
    const updatePayzenButton = () => {
      if (!isAppleEcosystem()) {
        const element = document.getElementById('GOOGLE_PAY_BUTTON_CUSTOM_PAYZEN');
        if (element) {
          if (googlePayRender) {
            element.style.cssText = `
          pointer-events: auto !important;
          display: block;
          position: absolute;
          inset: 0;
          opacity: 0;
          z-index: 10;
          max-height: 50px;
        `;
          } else {
            element.style.cssText = `
          pointer-events: none !important;
          display: none;
        `;
          }
        }
      }
      ;

      updatePayzenButton();

      const interval = setInterval(updatePayzenButton, 100);

      return () => clearInterval(interval);
    };

  }, [googlePayRender]);

  return (
    <>
      {payzen && payzen.paymentToken && (
        <>
          <button
            type="button"
            id="APPLE_PAY_BUTTON_CUSTOM"
            className={isAppleEcosystem() ? 'w-full visible' : 'w-full hidden'}
            style={{
              minHeight: '60px',
              padding: `${payzen && payzen.paymentToken ? '0' : '20px 0'}`,
            }}
          >
            <div
              className={`kr-smart-button text-[16px] opacity-0 h-[50px]`}
              kr-payment-method="APPLE_PAY"
            ></div>
          </button>
          {!isAppleEcosystem() && (
            <div className="relative inline-block w-full h-[50px]">
              {!googlePayRender ? (
                <div
                  className="bg-gray-400 text-white rounded-md px-6 py-3 inline-flex items-center justify-center gap-2 min-w-[100%] font-medium text-base h-[50px] opacity-75">
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"
                            fill="none" />
                    <path className="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  <span className="user-select-none">Initialisation de Google Pay...</span>
                </div>
              ) : (
                <button
                  className="bg-black text-white active:scale-95 transition-all duration-300 rounded-md px-6 py-3 inline-flex items-center justify-center gap-2 min-w-[100%] font-medium text-base h-[50px]"
                  onClick={clickGooglePayButton}
                  id="GOOGLE_PAY_BUTTON"
                  type="button"
                >
                  <svg width="41" height="17" viewBox="0 0 41 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                       className="scale-125">
                    <g>
                      <path
                        d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.569.996-2.615.996h-2.453v.001zM27.194 10.442c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568M40.954 4.755l-5.494 13.48h-1.47l2.042-4.394-3.604-8.662h1.635l2.632 6.571 2.536-6.571z"
                        fill="#ffffff" />
                      <path
                        d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944"
                        fill="#4285F4" />
                      <path
                        d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703"
                        fill="#34A853" />
                      <path
                        d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z"
                        fill="#FABB05" />
                      <path
                        d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774"
                        fill="#E94235" />
                    </g>
                  </svg>
                </button>

              )}


            </div>
          )}
          <div
            className={'kr-smart-button text-[16px] absolute opacity-0 inset-0 !w-1 !h-1 overflow-hidden'}
            kr-payment-method="GOOGLEPAY"
            style={{ visibility: !isAppleEcosystem() ? 'visible' : 'hidden' }}
            id="GOOGLE_PAY_BUTTON_CUSTOM_PAYZEN"
          />

        </>
      )}
    </>
  );
});

const PayByCardButton = memo(({ isPayzenModule, isSheetReady }) => {
  const { checkoutState } = useCheckout();
  const phoneNumber = checkoutState?.phoneNumber;
  const payzen = checkoutState?.payzen?.token;
  const theme = useTheme();
  const isDisabled = (!payzen && isPayzenModule) || !isSheetReady;

  return (
    <>
      <button
        id="pay-by-card-button"
        className="text-[1.7rem] flex justify-center text-center relative h-full w-full"
        disabled={isDisabled}
        style={{ fontFamily: 'geomanistbold' }}
      >
        {(isPayzenModule && !payzen?.paymentToken) || !isSheetReady
          ? 'Chargement...'
          : 'CB ET TITRE-RESTAURANT'}

        {theme?.buttonDecorations?.primaryButtonDecoration && (
          <img
            src={theme?.buttonDecorations?.primaryButtonDecoration?.image}
            alt="toileGRoupe"
            className="absolute translate-y-[20px]"
          />
        )}
      </button>
    </>
  );
});

export default Checkout;
